import React, { useState, useMemo, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  IconButton,
  Box,
  Grid,
  Tooltip,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  poppins400,
  poppins500,
  poppins700,
  fontsize10,
} from 'theme/common.style';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from 'antd/es/avatar/avatar';
import Dp from 'assets/dummy/buy.jpg';

const MessageIcon = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7842 16.0607C15.3544 16.0607 15.0051 15.7115 15.0051 15.2817C15.0051 14.8531 15.3544 14.5039 15.7842 14.5039C16.214 14.5039 16.5632 14.8531 16.5632 15.2817C16.5632 15.7115 16.214 16.0607 15.7842 16.0607ZM12.7556 16.0607C12.3258 16.0607 11.9766 15.7115 11.9766 15.2817C11.9766 14.8531 12.3258 14.5039 12.7556 14.5039C13.1855 14.5039 13.5347 14.8531 13.5347 15.2817C13.5347 15.7115 13.1855 16.0607 12.7556 16.0607ZM18.0338 15.2817C18.0338 15.7115 18.383 16.0607 18.8128 16.0607C19.2427 16.0607 19.5919 15.7115 19.5919 15.2817C19.5919 14.8531 19.2427 14.5039 18.8128 14.5039C18.383 14.5039 18.0338 14.8531 18.0338 15.2817Z"
        fill="#6C2AD2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.6409 8.4668C11.7676 8.4668 8.96094 11.6309 8.96094 15.1435C8.96094 16.2652 9.2876 17.4196 9.86094 18.4745C9.9676 18.6487 9.98094 18.8684 9.9076 19.076L9.46094 20.5716C9.36094 20.9322 9.6676 21.1986 10.0076 21.0917L11.3543 20.6918C11.7209 20.5716 12.0076 20.7245 12.3476 20.9322C13.3209 21.5057 14.5343 21.8001 15.6276 21.8001C18.9343 21.8001 22.2943 19.243 22.2943 15.1234C22.2943 11.5708 19.4276 8.4668 15.6409 8.4668Z"
        stroke="#6C2AD2"
        stroke-width="0.81025"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        opacity="0.1"
        x="1.125"
        y="0.632812"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};

const CallIcon = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="1.125"
        y="0.632812"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2414 11.764C11.4123 11.4811 12.3537 10.452 13.0255 10.4831C13.2264 10.4998 13.4039 10.6212 13.5481 10.7621C13.8793 11.0855 14.8274 12.3087 14.8812 12.5661C15.0121 13.1974 14.2599 13.5613 14.4901 14.1976C15.077 15.6338 16.0884 16.6451 17.5252 17.2314C18.1609 17.4616 18.5249 16.7094 19.1562 16.8409C19.413 16.8947 20.6368 17.8427 20.9603 18.1739C21.1006 18.3176 21.2227 18.4957 21.2393 18.6965C21.2643 19.4038 20.1714 20.3585 19.9584 20.4805C19.4558 20.84 18.8 20.8339 18.0006 20.4622C15.7699 19.5341 12.205 16.0365 11.2597 13.7216C10.898 12.9267 10.8731 12.2666 11.2414 11.764Z"
        stroke="#6C2AD2"
        stroke-width="0.81025"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const SixtySixWIcon = () => {
  return (
    <svg
      width="29"
      height="44"
      viewBox="0 0 29 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2415 2.6697C17.192 2.66086 17.1411 2.65625 17.089 2.65625C17.037 2.65625 16.9861 2.66086 16.9366 2.6697H9.75395C6.8989 2.6697 4.49219 4.98588 4.49219 7.81094V20.1079C4.49219 23.093 6.79317 25.4581 9.75395 25.4581H18.9242C21.7402 25.4581 24.0654 22.9765 24.0654 20.1079V9.58667C24.0654 9.36443 23.9795 9.1508 23.8255 8.99048L18.0117 2.9344C17.8493 2.76529 17.625 2.6697 17.3906 2.6697H17.2415ZM16.2282 4.39056L9.75385 4.39148C7.83525 4.39148 6.21386 5.95187 6.21386 7.81094V20.1079C6.21386 22.1525 7.75473 23.7363 9.75385 23.7363H18.9241C20.7632 23.7363 22.3435 22.0497 22.3435 20.1079L22.3428 10.6718L21.3379 10.6752C20.9549 10.6748 20.5193 10.674 20.0349 10.6729C18.0037 10.6686 16.3461 9.07653 16.2342 7.07249L16.2282 6.85625V4.39056ZM21.4005 8.9509L20.0387 8.95109C18.8846 8.94865 17.9499 8.01151 17.9499 6.85625V5.3566L21.4005 8.9509ZM16.8711 17.3575C17.3465 17.3575 17.7319 17.7429 17.7319 18.2184C17.7319 18.6542 17.4081 19.0144 16.9879 19.0714L16.8711 19.0793H10.6761C10.2006 19.0793 9.81519 18.6939 9.81519 18.2184C9.81519 17.7826 10.1391 17.4224 10.5593 17.3654L10.6761 17.3575H16.8711ZM15.3886 12.534C15.3886 12.0585 15.0031 11.6731 14.5277 11.6731H10.6755L10.5587 11.681C10.1385 11.738 9.8146 12.0982 9.8146 12.534C9.8146 13.0095 10.2 13.3949 10.6755 13.3949H14.5277L14.6445 13.387C15.0647 13.33 15.3886 12.9698 15.3886 12.534Z"
        fill="#6C2AD2"
      />
      <path
        opacity="0.6"
        d="M8.25547 38.5675C8.11336 37.8505 7.67089 37.492 6.92805 37.492C6.35316 37.492 5.92361 37.7149 5.63939 38.1606C5.35517 38.5998 5.2163 39.3265 5.22276 40.3406C5.37132 40.0047 5.61678 39.7431 5.95913 39.5558C6.30794 39.362 6.69551 39.2651 7.12183 39.2651C7.78716 39.2651 8.31683 39.4718 8.71086 39.8852C9.11135 40.2986 9.31159 40.8703 9.31159 41.6002C9.31159 42.0395 9.22439 42.4335 9.04998 42.7823C8.88204 43.1311 8.62366 43.4089 8.27485 43.6156C7.9325 43.8223 7.51586 43.9256 7.02494 43.9256C6.35962 43.9256 5.83963 43.7771 5.46498 43.4799C5.09034 43.1828 4.82873 42.7726 4.68016 42.2494C4.53159 41.7262 4.45731 41.0802 4.45731 40.3116C4.45731 37.9409 5.28412 36.7556 6.93774 36.7556C7.57077 36.7556 8.06814 36.9268 8.42987 37.2692C8.7916 37.6115 9.00477 38.0443 9.06936 38.5675H8.25547ZM6.93774 40.0112C6.65998 40.0112 6.39838 40.0693 6.15292 40.1856C5.90746 40.2954 5.70721 40.4666 5.55219 40.6991C5.40362 40.9252 5.32934 41.203 5.32934 41.5324C5.32934 42.0233 5.47144 42.4238 5.75566 42.7339C6.03988 43.0375 6.44682 43.1893 6.9765 43.1893C7.42866 43.1893 7.78716 43.0504 8.052 42.7726C8.32329 42.4884 8.45894 42.1073 8.45894 41.6293C8.45894 41.1255 8.32975 40.7314 8.07137 40.4472C7.813 40.1565 7.43512 40.0112 6.93774 40.0112ZM14.4058 38.5675C14.2637 37.8505 13.8212 37.492 13.0784 37.492C12.5035 37.492 12.074 37.7149 11.7897 38.1606C11.5055 38.5998 11.3667 39.3265 11.3731 40.3406C11.5217 40.0047 11.7671 39.7431 12.1095 39.5558C12.4583 39.362 12.8459 39.2651 13.2722 39.2651C13.9375 39.2651 14.4672 39.4718 14.8612 39.8852C15.2617 40.2986 15.4619 40.8703 15.4619 41.6002C15.4619 42.0395 15.3747 42.4335 15.2003 42.7823C15.0324 43.1311 14.774 43.4089 14.4252 43.6156C14.0829 43.8223 13.6662 43.9256 13.1753 43.9256C12.51 43.9256 11.99 43.7771 11.6153 43.4799C11.2407 43.1828 10.9791 42.7726 10.8305 42.2494C10.682 41.7262 10.6077 41.0802 10.6077 40.3116C10.6077 37.9409 11.4345 36.7556 13.0881 36.7556C13.7211 36.7556 14.2185 36.9268 14.5802 37.2692C14.942 37.6115 15.1551 38.0443 15.2197 38.5675H14.4058ZM13.0881 40.0112C12.8103 40.0112 12.5487 40.0693 12.3033 40.1856C12.0578 40.2954 11.8576 40.4666 11.7025 40.6991C11.554 40.9252 11.4797 41.203 11.4797 41.5324C11.4797 42.0233 11.6218 42.4238 11.906 42.7339C12.1902 43.0375 12.5972 43.1893 13.1269 43.1893C13.579 43.1893 13.9375 43.0504 14.2024 42.7726C14.4737 42.4884 14.6093 42.1073 14.6093 41.6293C14.6093 41.1255 14.4801 40.7314 14.2217 40.4472C13.9634 40.1565 13.5855 40.0112 13.0881 40.0112ZM23.8699 38.5966L22.213 43.9062H21.3023L20.0233 39.6915L18.7443 43.9062H17.8335L16.167 38.5966H17.0681L18.2889 43.0536L19.6066 38.5966H20.5077L21.7964 43.0633L22.9979 38.5966H23.8699Z"
        fill="#112347"
      />
    </svg>
  );
};

const DownArrowIcon = () => {
  return (
    <svg
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.292787 0.305289C0.480314 0.117818 0.734622 0.0125023 0.999786 0.0125023C1.26495 0.0125023 1.51926 0.117818 1.70679 0.305289L6.99979 5.59829L12.2928 0.305289C12.385 0.209779 12.4954 0.133596 12.6174 0.0811869C12.7394 0.0287779 12.8706 0.00119157 13.0034 3.77557e-05C13.1362 -0.00111606 13.2678 0.0241864 13.3907 0.0744673C13.5136 0.124748 13.6253 0.199001 13.7192 0.292894C13.8131 0.386787 13.8873 0.498438 13.9376 0.621335C13.9879 0.744231 14.0132 0.87591 14.012 1.00869C14.0109 1.14147 13.9833 1.27269 13.9309 1.39469C13.8785 1.5167 13.8023 1.62704 13.7068 1.71929L7.70679 7.71929C7.51926 7.90676 7.26495 8.01208 6.99979 8.01208C6.73462 8.01208 6.48031 7.90676 6.29279 7.71929L0.292787 1.71929C0.105316 1.53176 0 1.27745 0 1.01229C0 0.747125 0.105316 0.492817 0.292787 0.305289Z"
        fill="#0D0D0D"
      />
    </svg>
  );
};

const CheckBox = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.632812"
        width="16.205"
        height="16.205"
        rx="1.6205"
        fill="#C4C4C4"
        fill-opacity="0.22"
      />
    </svg>
  );
};

const GreyPaper = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#C4C4C4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
      />
    </svg>
  );
};
const ColorPaper = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

const CircularProgressWithProfileVendor = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{ color: '#C4C4C461' }}
        thickness={5}
        size={43}
      />
      <CircularProgress
        variant="determinate"
        value={props.value}
        sx={{ color: '#10D35E', position: 'absolute' }}
        thickness={5}
        size={43}
      />
      <Box
        sx={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          position: 'absolute',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
        >
          {props.profileImage == '' || props.profileImage == null ? (
            <Avatar
              style={{
                width: '36px',
                height: '36px',
                fontFamily: 'poppins',
                backgroundColor: '#666666',
              }}
            >
              {props.name}
            </Avatar>
          ) : (
            <Avatar
              alt={props.name}
              src={props.profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default function SelectAlternateWinnerDialog({
  open,
  onClose,
  tableData,
  privateoffer,
  selectedBuyer,
  setSelectedBuyer,
}) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(600));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches380 = useMediaQuery(theme.breakpoints.down(380));

  const [loading, setLoading] = useState(false);

  const currentPrivateOfferId = privateoffer?.privateOfferId;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={matches400 ? false : 'md'}
      fullScreen={matches400}
    >
      <Grid container height={'100%'}>
        <Grid
          container
          item
          xs={12}
          sx={{ padding: matchessm ? '20px' : '30px' }}
        >
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
                display: 'block',
              }}
            >
              Select Buyers
            </Typography>
          </Grid>

          <Grid item xs={12} marginTop={0}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                paddingLeft: '12px',
                display: 'block',
              }}
            >
              Choose which buyer should be nominated as winner. You can select
              only one recipient.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <DialogContent>
        {/* Buyers Table */}
        <TableContainer component={Paper} sx={{ maxHeight: 350 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ borderBottom: '1px solid #ddd' }}>
                <TableCell>
                  {/* <input
                                        type="checkbox"
                                        // checked={
                                        //   selectedBuyers.length > 0 &&
                                        //   selectedBuyers.length === eligibleBuyers.length
                                        // }
                                        ref={(el) => {
                                            // if (el) {
                                            //     el.indeterminate =
                                            //         selectedBuyers.length > 0 &&
                                            //         // selectedBuyers.length < eligibleBuyers.length;
                                            // }
                                        }}
                                        // onChange={handleSelectAllBuyers}
                                        // disabled={eligibleBuyers.length === 0}
                                        style={{
                                            accentColor: "#A55FFB",
                                            // cursor:
                                            //     eligibleBuyers.length === 0 ? "not-allowed" : "pointer",
                                            // width: "16px",
                                            // height: "16px",
                                        }}
                                    /> */}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: '10px',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    color: '#112347',
                    textAlign: 'left',
                    padding: '8px',
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '10px',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    color: '#112347',
                    textAlign: 'center',
                    padding: '8px',
                  }}
                >
                  Contact
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '10px',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    color: '#112347',
                    textAlign: 'center',
                    padding: '8px',
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '10px',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    color: '#112347',
                    textAlign: 'center',
                    padding: '8px',
                  }}
                >
                  Offers
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '10px',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    color: '#112347',
                    textAlign: 'center',
                    padding: '8px',
                  }}
                >
                  Number of Offers
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {tableData?.BuyerRegisterDetails?.length > 0 ? (
                tableData?.BuyerRegisterDetails.map((buyer) => {
                  const buyerId = buyer?.buyerDetails?.user?.userId;
                  const isWinner = buyer?.buyerOfferDetails?.isWinner == 1;
                  // const isSent = sentOfferBuyers?.some(
                  //     (b) => b?.buyerId == buyerId
                  // );
                  // const isDisabled =
                  //     isSent || disabledBuyerIds.includes(buyerId);

                  return (
                    <TableRow
                      key={buyerId}
                      sx={{
                        borderBottom: '1px solid #ddd',
                        minHeight: '50px',
                        opacity: isWinner ? 0.5 : 1,
                        pointerEvents: isWinner ? 'none' : 'auto',
                      }}
                    >
                      <TableCell
                        sx={{
                          width: '50px',
                          textAlign: 'center',
                          padding: '8px',
                          // cursor: sentCurrentOfferBuyerIds.includes(buyerId)
                          //     ? "not-allowed"
                          //     : "pointer",
                        }}
                        // onClick={() => {
                        //     if (!sentCurrentOfferBuyerIds.includes(buyerId)) {
                        //         handleSelectBuyer(buyerId);
                        //     }
                        // }}
                      >
                        <Tooltip
                        // title={
                        //     sentCurrentOfferBuyerIds.includes(buyerId)
                        //         ? "Offer already sent to this buyer"
                        //         : ""
                        // }
                        >
                          <span>
                            <input
                              type="checkbox"
                              checked={
                                selectedBuyer?.buyerDetails?.user?.userId ===
                                buyerId
                              }
                              // disabled={sentCurrentOfferBuyerIds.includes(buyerId)}
                              disabled={
                                !buyer?.buyerOfferDetails?.offerPrice ||
                                (tableData?.PropertyDetails?.stage == 'ST1' &&
                                  buyer?.buyerOfferDetails?.offerStatus !=
                                    'Accepted') ||
                                tableData?.PropertyDetails?.timerStatus ==
                                  'Pause'
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedBuyer(buyer); // select buyer
                                } else {
                                  setSelectedBuyer(null); // unselect buyer
                                }
                              }}
                              style={{
                                accentColor: '#A55FFB',
                                // cursor: sentCurrentOfferBuyerIds.includes(buyerId)
                                //     ? "not-allowed"
                                //     : "pointer",
                                width: '16px',
                                height: '16px',
                              }}
                            />
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Poppins',
                          textAlign: 'left',
                          padding: '22px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <CircularProgressWithProfileVendor
                          profileImage={buyer?.buyerDetails?.user?.userProfile}
                          value={buyer?.buyerDetails?.profileActivity}
                          name={
                            buyer?.buyerDetails?.user?.userName
                              .charAt(0)
                              ?.toUpperCase() +
                            buyer?.buyerDetails?.user?.userSurName
                              .charAt(0)
                              ?.toUpperCase()
                          }
                        />
                        <Typography
                          sx={{ fontFamily: 'Poppins', fontWeight: 500 }}
                        >
                          {buyer?.buyerDetails?.user?.userName +
                            ' ' +
                            buyer?.buyerDetails?.user?.userSurName}
                        </Typography>
                        <DownArrowIcon />
                      </TableCell>

                      <TableCell sx={{ textAlign: 'center', padding: '8px' }}>
                        <IconButton color="primary">
                          <MessageIcon />
                        </IconButton>
                        <IconButton color="primary">
                          <CallIcon />
                        </IconButton>
                      </TableCell>

                      <TableCell sx={{ textAlign: 'center', padding: '8px' }}>
                        {buyer?.buyerDetails?.is66Signed == 0 ? (
                          <GreyPaper />
                        ) : (
                          <ColorPaper />
                        )}
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: '14px',
                          fontWeight: '400',
                          fontFamily: 'Poppins',
                          color: '#112347',
                          textAlign: 'center',
                          padding: '8px',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '16px',
                              fontWeight: 500,
                              fontFamily: 'Poppins',
                            }}
                          >
                            {buyer?.buyerDetails?.buyerOffer?.offerPrice
                              ? buyer.buyerDetails.buyerOffer.offerPrice
                              : '-'}
                          </Typography>

                          {buyer?.buyerOfferDetails && (
                            <Typography
                              sx={{
                                ...poppins500,
                                ...fontsize10,
                                background:
                                  buyer?.buyerOfferDetails?.isWinner == 1
                                    ? 'rgba(108, 42, 210, 1)'
                                    : buyer?.buyerOfferDetails
                                        ?.logIsConditional == 1
                                    ? 'rgba(237, 11, 11, 0.6)'
                                    : buyer?.buyerOfferDetails
                                        ?.logIsConditional == 0
                                    ? 'rgba(16, 211, 94, 1)'
                                    : '-',
                                borderRadius: '5px',
                                color: 'white',
                                padding: '4px 8px',
                                height: '22px',
                                minWidth: '90px',
                                marginTop: '4px',
                              }}
                            >
                              {buyer?.buyerOfferDetails?.isWinner == 1
                                ? 'Winner'
                                : buyer?.buyerOfferDetails?.logIsConditional ==
                                  1
                                ? 'Conditional'
                                : 'Unconditional'}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: '14px',
                          fontWeight: '400',
                          fontFamily: 'Poppins',
                          color: '#112347',
                          textAlign: 'center',
                          padding: '8px',
                        }}
                      >
                        {buyer?.buyerDetails?.noOfOffers
                          ? buyer?.buyerDetails?.noOfOffers
                          : '-'}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
                    <Typography
                      sx={{
                        fontSize: '16px',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        color: '#666666',
                      }}
                    >
                      No buyers available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <Grid
        container
        item
        xs={12}
        sx={{ padding: matchessm ? '20px' : '30px' }}
      >
        <Grid
          item
          xs={12}
          display={'flex'}
          alignItems={'center'}
          padding={'0px 0px 15px 0'}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: '400',
              fontFamily: 'Poppins',
              color: '#666666',
            }}
          >
            {/* ({selectedBuyers.length}) Buyers selected */}
          </Typography>
        </Grid>
      </Grid>

      <DialogActions sx={{ marginBottom: '24px' }}>
        <Grid
          container
          spacing={2}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            marginTop: 2,
            marginRight: 3,
          }}
        >
          <Grid item>
            <Button
              variant="outlined"
              disabled={loading}
              sx={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={() => {
                // Clear the selected buyers
                // setSelectedBuyers([]);

                // Optionally, reset any other states, such as loading or disabledBuyerIds
                setLoading(false);

                // Close the dialog or trigger the onClose function
                onClose();
              }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              sx={{
                padding: matchessm ? '6px 30px' : '10px 50px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#FFFFFF',
                fontWeight: 400,
                fontFamily: 'Poppins',
                backgroundColor: '#4CA4D6',
                textTransform: 'none',
                borderRadius: '5px',
                '&:hover': {
                  backgroundColor: '#4CA4D6',
                },
                '&.Mui-disabled': {
                  backgroundColor: '#4CA4D6',
                  color: '#fff',
                  opacity: 0.7,
                  cursor: 'not-allowed', // Ensure the cursor is explicitly defined here
                  pointerEvents: 'auto',
                },
              }}
              onClick={onClose}
              // disabled={loading || selectedBuyers.length === 0}
            >
              {loading ? (
                <CircularProgress size={20} sx={{ color: '#fff' }} />
              ) : (
                'Confirm'
              )}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
